import templates from 'src/templates/input/base';
import View from 'src/components/shared/view';
import PartialInputView from './partialInputView';
import domSelector from 'src/utils/domSelector';
import DOM_SELECTOR_CONFIG from 'src/config/domSelectorConfig';
import clickTracker from 'src/utils/events/clickEvent/clickTracker';
import getTemplate from 'src/components/shared/optionHandlers/templateHandler';

const {
  INPUT_VIEW,
  PARTIALS_SUBVIEW,
  CONTINUE_BUTTON
} = DOM_SELECTOR_CONFIG.INPUT_DATA_SELECTORS;

const DOM_SELECTORS = {
  dataView: INPUT_VIEW,
  partialsSubview: PARTIALS_SUBVIEW,
  continueButton: CONTINUE_BUTTON
};

class InputView extends View {
  constructor() {
    super();
    this.onInputUpdate = this.onInputUpdate.bind(this);
    this.onInputCompleted = this.onInputCompleted.bind(this);
    this.onKeypressed = this.onKeypressed.bind(this);
  }

  render(renderProps) {
    const template = getTemplate(templates, renderProps.templateScope.options);
    const renderedTemplate = template(Object.assign(renderProps.templateScope, DOM_SELECTORS));

    this.destroy();
    this.appendToBody(renderedTemplate);

    this.inputContainer = domSelector.getInputContainer();
    this.partialsContainer = domSelector.getInputPartialsContainer();
    this.continueButton = domSelector.getInputContinueButton();

    this.renderPartials(renderProps);
    this.bindEvents(renderProps);
  }

  initAutofocus() {
    this.partialViews.some((partialView) => {
      const shouldFocusInput = partialView.shouldFocus();
      if (shouldFocusInput) partialView.inputElement.focus();
      return shouldFocusInput;
    });
  }

  destroyPartials() {
    if (this.partialViews) this.partialViews.forEach((partial) => partial.destroy());
    this.partialViews = null;
  }

  renderPartials({ registrationPartials }) {
    this.destroyPartials();

    this.partialViews = registrationPartials.map((templateScope) => (
      new PartialInputView({ templateScope, body: this.partialsContainer })
    ));

    this.initAutofocus();
    this.bindPartialEvents();
  }

  bindEvents({ templateScope }) {
    domSelector.getOauthButtons().forEach((element) => clickTracker.initialize(element));
    clickTracker.initialize(domSelector.getSignInLink(templateScope.nodeType));
    this.continueButton.addEventListener('click', this.onInputCompleted);
    this.inputContainer.addEventListener('keypress', this.onKeypressed);
  }


  bindPartialEvents() {
    this.partialViews.forEach(({ container }) =>
      container.addEventListener('input', this.onInputUpdate)
    );
  }

  onInputUpdate() {
    this.emitChange(this.getInputValues());
  }

  removePartialEvents() {
    this.partialViews.forEach(({ container }) =>
      container.removeEventListener('input', this.onInputUpdate)
    );
  }

  getInputValues() {
    const inputKeysAndValues = this.partialViews.map((partial) => partial.getInputKeyAndValue());
    return Object.assign(...inputKeysAndValues);
  }

  destroy() {
    if (this.inputContainer) {
      this.removePartialEvents();
      this.destroyPartials();
      this.continueButton.removeEventListener('click', this.onInputCompleted);
      this.inputContainer.removeEventListener('keypress', this.onKeypressed);
      this.body.removeChild(this.inputContainer);

      this.inputContainer = null;
      this.partialsContainer = null;
      this.continueButton = null;
    }
    super.destroy();
  }

  onKeypressed(event) {
    const KEYCODE_ENTER = 13;
    if (event.keyCode === KEYCODE_ENTER && this.continueButton.disabled === false) {
      this.onInputCompleted(event);
    }
  }

  onInputCompleted(event) {
    event.preventDefault();
    this.continueButton.disabled = true;
    this.emitCompleted(this.getInputValues());
  }
}

export default InputView;
